import "./Channel.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import queryString from "querystring";

import { Button } from "antd";
import moment from "moment";

import Swal from "sweetalert2";

import inquiryApi from "../../apis/Inquiry.api";
import settlementApi from "../../apis/Settlement.api";
import InquiryEachComponent from "../../components/channel/inquiryBoard/InquiryEachComponent";
import { setLoading } from "../../redux/store/common/commonDuck";

const InquiryBoardEach = (props) => {
	const inquiryId = props.match.params?.id;

	const dispatch = useDispatch();
	const history = useHistory();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [inquiryValue, setInquiryValue] = useState({});

	useEffect(() => {
		if (!cUser?.id) {
			getInquiryBoard();
		}
	}, [cUser]);

	useEffect(() => {
		if (!!inquiryId && !!reduxChannel?.user_id && !!cUser?.id) {
			getInquiryBoard();
		}
	}, [inquiryId, reduxChannel, cUser]);

	const [inquiryImageList, setInquiryImageList] = useState([]);
	const [answerValue, setAnswerValue] = useState([]);
	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);

	useEffect(() => {
		if (inquiryValue?.is_secret) {
			const queryJson = queryString.parse(
				history.location.search?.replace("?", "")
			);
			const userId = queryJson?.userId;
			const influencerId = queryJson?.id;
			if (!cUser?.id) {
				if (!userId) {
					Swal.fire({
						customClass: "alert-custom",
						text: "비밀글입니다.",
						confirmButtonText: "확인",
					}).then(() => {
						setIsLoading(false);
						history.replace(
							`/together/channel/inquiry/board?id=${influencerId}`
						);
					});
					// setIsLoading(false);
					// window.alert("비밀글입니다.");
					// history.replace(`/together/channel/inquiry/board?id=${influencerId}`)
					// console.log(`/together/channel/inquiry/board?id=${influencerId}`)
				}
			}
		}
	}, [inquiryValue]);

	/**
	 * 상담게시글 단건 조회
	 * @returns {Promise<void>}
	 */
	const getInquiryBoard = async () => {
		const param = {
			inquiryId: inquiryId,
			influencerId: reduxChannel?.user_id,
			userId: cUser?.id ?? 0,
		};

		const res = await inquiryApi.readInquiryBoard(param);

		if (res.code === 200) {
			setInquiryValue(res.result?.inquiry);
			// 질문 이미지 리스트
			if (res.result?.inquiryImageList?.length > 0) {
				let list = [];
				let photos = [];
				for (let i = 0; i < res.result?.inquiryImageList?.length; i++) {
					let resultImageList = res.result?.inquiryImageList[i];
					let source = `${process.env.REACT_APP_S3_HOST}/image/together/inquiry/board/${reduxChannel?.user_id}/${resultImageList?.title}.${resultImageList?.img_type}`;
					list.push(source);
					photos.push({
						source: source,
						type: `image/${resultImageList?.img_type}`,
					});
				}
				// 최대 5개까지
				setInquiryImageList(list.slice(0, 5));
			} else {
				setInquiryImageList([]);
			}
			// 답변 이미지 리스트
			if (res.result?.answerImageList?.length > 0) {
				let list = [];
				let photos = [];
				for (let i = 0; i < res.result?.answerImageList?.length; i++) {
					let resultImageList = res.result?.answerImageList[i];
					let source = `${process.env.REACT_APP_S3_HOST}/image/together/inquiry/answer/${reduxChannel?.user_id}/${resultImageList?.title}.${resultImageList?.img_type}`;
					list.push(source);
					photos.push({
						source: source,
						type: `image/${resultImageList?.img_type}`,
					});
				}
				// 최대 5개까지
				setImageList(list.slice(0, 5));
				setPhotoList(photos.slice(0, 5));
			} else {
				setImageList([]);
				setPhotoList([]);
			}

			// 답변 내용
			setAnswerValue(
				{
					...res.result?.answer,
					type: "answer",
				} ?? {}
			);
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("get-inquiry-each-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 수정하기 페이지 이동
	 * @param item
	 */
	const updateInquiryBoard = () => {
		history.push(
			`/together/channel/inquiry/board/update/${inquiryId}?id=${reduxChannel?.influencer_id}`
		);
	};

	/**
	 * 삭제하기 페이지
	 * @returns {Promise<void>}
	 */
	const deleteInquiryBoard = async () => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 글을 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				const param = {
					inquiryId: inquiryId,
					influencerId: reduxChannel?.user_id,
					userId: cUser?.id,
				};
				const res = await inquiryApi.deleteInquiry(param);
				if (res.code === 200) {
					Swal.fire({
						customClass: "alert-custom",
						text: "성공적으로 삭제되었습니다!",
						confirmButtonText: "확인",
					}).then(() => {
						history.replace(
							`/together/channel/inquiry/board?id=${reduxChannel?.influencer_id}`
						);
						setIsLoading(false);
					});
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						setIsLoading(false);
					});
				}
			}
		});
	};

	return (
		<div className="channel-home">
			<div className={`home-body`}>
				<div className={`max-width-apply`}>
					<div className={`inquiry-board-each-container`}>
						<InquiryEachComponent
							inquiryValue={inquiryValue}
							inquiryImageList={inquiryImageList}
						/>
						{!!answerValue?.id && (
							<InquiryEachComponent
								inquiryValue={answerValue}
								inquiryImageList={imageList}
							/>
						)}

						<div className={`inquiry-board-each-footer`}>
							{!!inquiryValue?.is_mine && (
								<div className={`inquiry-board-each-button-group`}>
									{!answerValue?.id && (
										<Button onClick={updateInquiryBoard} loading={isLoading}>
											수정
										</Button>
									)}
									<Button onClick={deleteInquiryBoard} loading={isLoading}>
										삭제
									</Button>
								</div>
							)}
							<Button
								className={`black`}
								onClick={() => {
									history.push(
										`/together/channel/inquiry/board?id=${reduxChannel?.influencer_id}`
									);
								}}
								loading={isLoading}
							>
								목록으로
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default InquiryBoardEach;
